(() => {
  const name = 'swipe';

  App.common = App.common || {};

  App.common[name] = (() => {
    const Swipe = function SwipeConstructor(elem) {
      this.elem = elem;
      this.eventHandlers = {};
      this.touchstartX = 0;
      this.touchstartY = 0;
      this.touchendX = 0;
      this.touchendY = 0;
      this.swipedir = 'none';
      this.setEventListener(this.elem);
    };

    Swipe.prototype = {
      on(event, handler) {
        this.eventHandlers[event] = handler;
      },

      off(event) {
        this.eventHandlers[event] = null;
      },

      trigger(event) {
        const eventHandler = this.eventHandlers[event];
        if (eventHandler && typeof eventHandler === 'function') {
          eventHandler();
        }
      },

      handleSwipe() {
        const minX = 20;
        const maxX = 40;
        const minY = 40;
        const maxY = 50;

        if ((((this.touchendX - minX > this.touchstartX)
          || (this.touchendX + minX < this.touchstartX))
          && ((this.touchendY < this.touchstartY + maxY)
            && (this.touchstartY > this.touchendY - maxY)))) {
          if (this.touchendX > this.touchstartX) {
            this.swipedir = 'right';
          } else {
            this.swipedir = 'left';
          }
        }

        if ((((this.touchendY - minY > this.touchstartY)
          || (this.touchendY + minY < this.touchstartY))
          && ((this.touchendX < this.touchstartX + maxX)
            && (this.touchstartX > this.touchendX - maxX)))) {
          if (this.touchendY > this.touchstartY) {
            this.swipedir = 'down';
          } else {
            this.swipedir = 'up';
          }
        }

        this.trigger(`swipe${this.swipedir}`);
      },

      setEventListener(elem) {
        const getNewTime = () => new Date().getTime();
        const self = this;
        let timer = null;

        elem.addEventListener('touchstart', (e) => {
          self.touchstartX = e.touches[0].screenX;
          self.touchstartY = e.touches[0].screenY;
          timer = getNewTime();
        }, false);

        elem.addEventListener('touchend', (e) => {
          if (getNewTime() - timer > 100) {
            self.handleSwipe(e);
          }
        }, false);

        elem.addEventListener('touchmove', (e) => {
          self.touchendX = e.touches[0].screenX;
          self.touchendY = e.touches[0].screenY;
        }, false);
      },
    };

    return Swipe;
  })();
})();
